import { StyleSheet } from 'react-native';
import { neutrals } from 'src/theme/colors';

export const style = StyleSheet.create({
  container: {
    position: 'absolute',
    bottom: 0,
    zIndex: 5,
    backgroundColor: neutrals.white,
    borderTopRightRadius: 20,
    borderTopLeftRadius: 20,
    shadowColor: neutrals.black,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.15,
    shadowRadius: 12,
    width: '100%',
    paddingVertical: 12,
  },
  sliderWrapper: {
    paddingBottom: 20,
    paddingHorizontal: 10,
    paddingTop: 8,
  },
  mainContent: {
    borderTopWidth: 1,
    borderColor: neutrals.neutralGrays.dust,
    paddingTop: 16,
  },
});
